/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataRequestModel } from '../../models/data-request-model';
import { ProfileReportModel } from '../../models/profile-report-model';

export interface ScanScanReportProfileIdPost$Params {
  profileId: string;
      body?: DataRequestModel
}

export function scanScanReportProfileIdPost(http: HttpClient, rootUrl: string, params: ScanScanReportProfileIdPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ProfileReportModel>> {
  const rb = new RequestBuilder(rootUrl, scanScanReportProfileIdPost.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ProfileReportModel>;
    })
  );
}

scanScanReportProfileIdPost.PATH = '/Scan/ScanReport/{profileId}';
